interface SoProducts {
    id?: number;
    name: string;
    qtyOrdered: number;
    qtyShipped: number;
    qtyReceived: number;
    etd: string | null;
    eta: string | null;
    ship_arrived_date: string;
    status: string;
}

type OrderStatusViewProps = {
    products: SoProducts[];
};

const OrderStatusView = (props: OrderStatusViewProps) => {
    const columns = ["ETA", "Ship Arrived Date", "Status"];

    function isDate1BeforeDate2(date1: string, date2: string): boolean {
        return new Date(date1) < new Date(date2);
    }

    function isDateOlderThanToday(dateString: string): boolean {
        const inputDate = new Date(dateString);
        const today = new Date();

        inputDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return inputDate < today;
    }

    function isDateInTwoDays(dateString: string): boolean {
        const inputDate = new Date(dateString);
        const today = new Date();
        const twoDaysFromNow = new Date();

        inputDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        twoDaysFromNow.setHours(0, 0, 0, 0);
        twoDaysFromNow.setDate(today.getDate() + 2);

        return inputDate.getTime() === twoDaysFromNow.getTime();
    }

    const getETAColor = function (
        date: string | null,
        ship_arrived_date: string | null,
    ) {
        if (ship_arrived_date) {
            return "#1cf508ff";
        }

        if (!date) {
            return "#efefef";
        }

        if (isDateOlderThanToday(date)) {
            return "#f57242ff";
        } else if (isDateInTwoDays(date)) {
            return "#f5f108ff";
        } else {
            return "#1cf508ff";
        }
    };

    const getShipArrivedDateColor = function (
        etaDate: string,
        ataDate: string,
    ) {
        if (isDate1BeforeDate2(etaDate, ataDate)) {
            return "#f57242ff";
        } else {
            return "#1cf508ff";
        }
    };

    const formatDate = function (dateString: string | null) {
        if (!dateString) {
            return null;
        } else {
            const date = new Date(dateString);
            const options: Intl.DateTimeFormatOptions = {
                month: "short",
                day: "numeric",
            };

            return date.toLocaleDateString("en-US", options);
        }
    };

    const getStatus = function (row: any) {
        if (row.qtyReceived > 0) {
            return "Delivered";
        }

        if (!row.eta && !row.ship_arrived_date) {
            return "Preparing for export";
        } else if (row.eta && !row.ship_arrived_date) {
            return "In Transit Sea";
        } else {
            return "Customs Clearance";
        }
    };

    const getStatusColor = function (name: string) {
        if (name == "Preparing for export") {
            return "#e5e5e5ff";
        } else if (name == "In Transit Sea") {
            return "#58deccff";
        } else if (name == "Customs Clearance") {
            return "#5f8bbbff";
        } else if (name == "Delivered") {
            return "#81ed8cff";
        } else {
            return "#ffff";
        }
    };

    return (
        <table
            className="table table-hover mb-0"
            style={{
                borderRight: "1px solid #efefef",
            }}
        >
            <thead
                style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#0d6efd",
                    color: "white",
                    zIndex: 10,
                }}
            >
                <tr>
                    {columns.map((column: string, idx) => (
                        <th
                            key={idx}
                            className="fw-semibold text-uppercase text-center"
                            style={{
                                fontSize: "clamp(0.5rem, 2vw, 0.7rem)", // Responsive between 0.5rem and 0.7rem
                                color: "#6c757d",
                                padding: "0.6rem",
                                borderBottom: "2px solid #dee2e6",
                                whiteSpace: "nowrap",
                                // minWidth: column == "Status" ? 200 : 80,
                            }}
                        >
                            {column}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {props.products.map((row, idx) => (
                    <tr
                        key={idx}
                        style={{
                            borderBottom: "1px solid #f0f0f0",
                            height: 50,
                        }}
                    >
                        {columns.map((column, dateIdx) => (
                            <td
                                key={dateIdx}
                                className="text-center"
                                style={{
                                    // maxWidth: 10,
                                    fontSize: "clamp(0.5rem, 2vw, 0.7rem)",
                                    backgroundColor:
                                        column == "Status"
                                            ? getStatusColor(getStatus(row))
                                            : "#fff",
                                }}
                            >
                                {column == "ETA" &&
                                    row.status !== "Preparing for export" && (
                                        <span
                                            className="badge"
                                            style={{
                                                backgroundColor: getETAColor(
                                                    row.eta,
                                                    row.ship_arrived_date,
                                                ),
                                                fontWeight: "700",
                                                fontSize:
                                                    "clamp(0.5rem, 2vw, 0.7rem)",
                                                color: "#333",
                                            }}
                                        >
                                            {formatDate(row.eta) || "Not Found"}
                                        </span>
                                    )}
                                {column == "Ship Arrived Date" && (
                                    <span
                                        className="badge"
                                        style={{
                                            backgroundColor:
                                                row.ship_arrived_date
                                                    ? "#1cf508ff"
                                                    : "#efefef",
                                            fontWeight: "700",
                                            fontSize:
                                                "clamp(0.5rem, 2vw, 0.7rem)",
                                            color: "#333",
                                        }}
                                    >
                                        {formatDate(row.ship_arrived_date) ||
                                            "Not Found"}
                                    </span>
                                )}
                                {column == "Status" && (
                                    <p
                                        style={{
                                            display: "-webkit-box",
                                            WebkitLineClamp: 1,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {getStatus(row)}
                                    </p>
                                )}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
export default OrderStatusView;
